import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  imports: [RouterOutlet],
  selector: 'nutt-root',
  template: `<router-outlet />`,
})
export class AppComponent {}
